module.exports = __webpack_public_path__ + "img/Desktop_Slide1.d2a08329.svg";